import dynamic from 'next/dynamic';
import { ReactElement } from 'react';
import { LeftImageRightTextProps } from './LeftImageRightText';

const Comp = dynamic(() => import('./LeftImageRightText'));

export default function RightImageLeftText(props: LeftImageRightTextProps): ReactElement {
  return <Comp {...props} rightImage={true} />;
}
